import React from 'react'
import { connect } from 'react-redux'
import { defaultTo } from 'lodash'

import { fetchStations, clearStation } from '../../actions/remote_api'
import SearchSelect from '../../modules/select/SearchSelect'

class StationSearchSelect extends React.Component {
  render() {
    return (
      <SearchSelect
        {...this.props}
        options={this.props.options}
        createQuery={defaultTo(this.props.createQuery, createQuery)}
        createLabel={createLabel}
        defaultValueQuery={defaultValueQuery}
        selectId="stationOptions"
      />
    )
  }
}

const createQuery = (searchText) => ({
  q: searchText ? searchText.toLowerCase() : undefined,
})

const defaultValueQuery = (initialId) => ({
  _id: initialId,
})

const createLabel = (station) => station.name

export default connect(null, {
  fetchOptions: fetchStations,
  clearOptions: clearStation,
})(StationSearchSelect)
